import type { ComponentRohsBriefingStep } from '@/shared/briefing/buildComponentRohsBriefing'
import { V2ComponentRohsBriefingStepShell } from './V2ComponentRohsBriefingStepShell'

export function V2ComponentRohsWaitingStep({
  step,
  index,
}: {
  step: ComponentRohsBriefingStep
  index: number
}) {
  return <V2ComponentRohsBriefingStepShell step={step} index={index} />
}
